export const PATHS = {
  HOME: "/",
  LOGIN: "/redirect=",
};
